import { useState as a, useEffect as w } from "react";
const y = o => {
    var e;
    return (e = o.current) == null ? void 0 : e.querySelectorAll('a[href], button[data-mosaic="true"]');
  },
  v = _ref => {
    let {
      elementsToNavigate: o,
      event: e,
      menuButton: u,
      isTablet: f,
      setOpenSubMenu: i
    } = _ref;
    o.forEach((s, r) => {
      if (s === e.target) {
        if (e.key === "ArrowRight" || e.key === "ArrowDown") {
          e.preventDefault();
          const n = o[r + 1];
          return n ? n.focus() : null;
        }
        if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
          e.preventDefault();
          const n = o[r - 1];
          return n ? n.focus() : null;
        }
        if (!e.shiftKey && e.key === "Tab" && r === o.length - 1 && f) {
          e.preventDefault();
          const n = u == null ? void 0 : u.nextElementSibling;
          return n == null || n.focus(), i(!1);
        }
        if (e.shiftKey && e.key === "Tab" && r === 0 && f) return e.preventDefault(), u == null || u.focus(), i(!1);
      }
    });
  },
  p = _ref2 => {
    let {
      openSubMenu: o,
      setOpenSubMenu: e,
      menuButton: u,
      profileButton: f,
      wrapperRef: i
    } = _ref2;
    const [s, r] = a(-1);
    w(() => {
      const n = t => {
        if (t.key !== "ArrowRight" && t.key !== "ArrowDown" && t.key !== "ArrowLeft" && t.key !== "ArrowUp" && t.key !== "Tab" && t.key !== "Escape" && t.shiftKey) return;
        if (!o) return r(-1);
        const l = window.innerWidth < 840;
        if (t.key === "Escape") return e(!1), l ? u == null ? void 0 : u.focus() : f == null ? void 0 : f.focus();
        const c = y(i);
        if ((t.key === "ArrowDown" || !t.shiftKey && t.key === "Tab") && s === -1) return t.preventDefault(), c.item(0).focus(), r(0);
        v({
          elementsToNavigate: c,
          event: t,
          setOpenSubMenu: e,
          menuButton: u,
          isTablet: l
        });
      };
      return window.addEventListener("keydown", n), () => {
        window.removeEventListener("keydown", n);
      };
    }, [s, u, o, f, e, i]);
  };
export { p as useOverflowNavigation };